import { useMemo } from "react";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ControleEstoqueModal } from "./components/controle_modal";
import { useControleEstoqueListaViewModel } from "../../viewModels/controle_estoque_lista_view_model";
import { GenerateControleEstoqueColumns } from "./columns/controle_estoque";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { ControleEstoque } from "../../../domain/models/controle_estoque_lista";
import { useNavigate } from "react-router";

export const ControleEstoqueLista = () => {

  const viewModel = useControleEstoqueListaViewModel();
  const navigate = useNavigate();

  const ControleEstoqueListalColumns = useMemo(() => {
    return GenerateControleEstoqueColumns({
      onActionEditar: viewModel.handleCadastroControleEstoqueOpenState,
      onActionDeletar: viewModel.handleDeleteModalOpenState,
      navigate
    });
  }, [navigate, viewModel.handleCadastroControleEstoqueOpenState, viewModel.handleDeleteModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroControleEstoqueOpenState(null, true)}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Estoque
            </Link>

          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Controle Estoque</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            centroDeCusto={viewModel.filters.centroDeCusto}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.DescricaoPesquisa}


          />
          <StyledDataGrid
            tableName="Controle_Estoque_lista"
            disableColumnMenu={false}
            getRowId={(row: ControleEstoque) => row.IdControleEstoque}
            columns={ControleEstoqueListalColumns}
            loading={viewModel.loading}
            rows={viewModel.controleEstoqueLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ["IdControleEstoque"],
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
      <ControleEstoqueModal
        loading={viewModel.loading}
        onClose={() => viewModel.setControleEstoqueModal(false)}
        onSubmit={viewModel.handleControleEstoqueSubmit}
        open={viewModel.controleEstoqueModal}
        saving={viewModel.saving}
        selectedControleEstoque={viewModel.selectedControleEstoque}
        centroCustoLista={viewModel.centroDeCustoLista}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />


      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
      <DeleteDialog
        open={viewModel.deleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirma} />

    </>
  )
};
